import { gql } from '@apollo/client/core';
import ClientFragment from '@/components/partials/portfolio/PortfolioClientMixin/Client.fragment';

const UpdateClientForPublicPortfolioCurrentUser = gql`
  ${ClientFragment}

  mutation updateClientForPublicPortfolioCurrentUser($input: UpdateClientForPublicPortfolioCurrentUserInput!) {
    updateClientForPublicPortfolioCurrentUser(input: $input) {
      ...ClientFragment
    }
  }
`;
export default UpdateClientForPublicPortfolioCurrentUser;
